// Useful utility function to merge tailwind classes with clsx with just one function call
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

export const clsxMerge = (...args: Parameters<typeof clsx>) =>
  twMerge(clsx(...args));
